import React, { Component, useEffect, useImperativeHandle } from "react";
import store from "@/redux/store";
import {  useSelector } from "react-redux";
import { useForm, SubmitHandler, Controller, useWatch } from "react-hook-form"
import { FieldHolder } from "@/components/holders/FieldHolder";

type IProps = {
    [propName: string]: any
}


export function AddressEditView({...props}:IProps) {
    const data = props?.window?.data?.data;
    const addressCollection = props.getValues('addresses');
    console.debug("asdasdasd",props.getValues());
    console.debug("asdasdasd",addressCollection.first());
    const todoIds = useSelector((state) => store.getState().AuthReducer.testme)
  const { register, handleSubmit, watch, reset, control, setValue, getValues, formState, } = useForm<any>({
      defaultValues: addressCollection.first()
    })
const onSubmit = (data) => {
    
}

  useImperativeHandle(props.ref, () => {
    return {
        testme() {
            return getValues();
        }
      // ... your methods ...
    };
  }, []);
    


    return (<>
    <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSubmit)}>
                      <input
                    id="key"
                    name="key"
                    type="hidden"
                    {...register("key")}
                    key={(props.data && props.data.key) ?? null} />


          <div className="">
            <div className="space-y-8 pb-12 sm:space-y-0   sm:pb-0">


                <div className="grid grid-cols-12 gap-3">


            <FieldHolder colspan="12" smcolspan="8" label="Adres" id={`address`} error={props?.state?.error ?? null}>                
                  <input
                    type="text"
                    {...register('address')}
                    key={(data && data.address) ?? null}
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>

              </div>
                <div className="grid grid-cols-12 gap-3">
            <FieldHolder colspan="12" smcolspan="3" label="Postcode" id={`zipcode`} error={props?.state?.error ?? null}>                
                  <input
                    type="text"
                    {...register('zipcode')}
                    key={(data && data.zipcode) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            <FieldHolder colspan="12" smcolspan="5" label="Plaats" id={`residence`} error={props?.state?.error ?? null}>                
                  <input
                    type="text"
                    {...register('residence')}
                    key={(data && data.residence) ?? null}
                    
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
              </div>
            </div>
          </div>


          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
    
    </form>
    
    </>);
}